// extracted by mini-css-extract-plugin
module.exports = {"session-metadata":"session-metadata__session-metadata___2vT2K"};